/** Window event name for explicit Activity dock open requests. */
export const ACTIVITY_DOCK_OPEN_EVENT = "bb-activity-dock-open";

/** Optional detail for `ACTIVITY_DOCK_OPEN_EVENT` (FF-DOCK-3 Ask-from-sidebar). */
export type ActivityDockOpenDetail = {
  /** Bypass assist-level gate (explicit user action from sidebar Firefly). */
  force?: boolean;
  /** After open, expand Ask Firefly and focus the input. */
  expandAsk?: boolean;
  /** After open, scroll/expand a dock section (WC-V20-HOST-3). */
  focusSection?: "messages";
  /** Bell click toggles the shared panel instead of forcing it open. */
  toggle?: boolean;
};

/**
 * Pending focus / Ask expand set when dispatching an open before the
 * expanded panel mounts. Consumers take them on mount so late listeners
 * still honor sidebar "Ask Firefly" (dev-sync e7ece412).
 */
let pendingFocusSection: ActivityDockOpenDetail["focusSection"] | null = null;
let pendingExpandAsk = false;

export function dispatchActivityDockOpen(detail: ActivityDockOpenDetail = {}): void {
  if (detail.focusSection) pendingFocusSection = detail.focusSection;
  if (detail.expandAsk) pendingExpandAsk = true;
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent<ActivityDockOpenDetail>(ACTIVITY_DOCK_OPEN_EVENT, { detail }));
}

export function takePendingDockFocusSection(): ActivityDockOpenDetail["focusSection"] | null {
  const next = pendingFocusSection;
  pendingFocusSection = null;
  return next;
}

export function takePendingExpandAsk(): boolean {
  const next = pendingExpandAsk;
  pendingExpandAsk = false;
  return next;
}

/**
 * Open the shared attention panel. Docked mode stays in the bell;
 * floating mode stays on the Firefly tab.
 */
export async function openFireflyActivityDock(detail: ActivityDockOpenDetail = {}): Promise<void> {
  if (typeof window === "undefined") return;
  dispatchActivityDockOpen(detail);
}
